import { SelectableClient } from '../../services/SelectClient/selectClient.service';

export const filterClientsBySearch = (clients: SelectableClient[], search: string): SelectableClient[] => {
  const query = search.trim().toLowerCase();
  if (!query) return clients;
  return clients.filter((client) => client.name.toLowerCase().includes(query));
};
